<template>
    <div class="layout__container">
        <div class="layout__width-80 layout__padding-clear">

            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-70 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                    <h2 class="text__colour-teal">Directmailr Order Details</h2>
                    <div class="layout__padding-20-0 text__size-18 text__colour-grey">Here you can see the details of
                        your Directmailr order.
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear">

                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="customerInformation = !customerInformation">
                            <span v-if="this.customerInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.customerInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Customer Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.customerInformation">
                        <p class="text_colour-909399">Contact Name</p>
                        <p>{{this.orderOverview.name}}</p>
                        <br>
                        <p class="text_colour-909399">Contact Email</p>
                        <p>{{this.orderOverview.email}}</p>
                        <br>
                        <p class="text_colour-909399">Branch Code</p>
                        <p>{{this.orderOverview.customerRef}}</p>
                        <br>
                        <p class="text_colour-909399">Account Type</p>
                        <p>
                            <span v-show="this.orderOverview.customerRef === 'PFCC1'">Online Customer</span>
                            <span v-show="this.orderOverview.customerRef !== 'PFCC1'">Account Customer</span>
                        </p>
                        <br>
                        <p class="text_colour-909399">Billing Address</p>
                        <p>{{this.customerDetails.address1}}</p>
                        <p>{{this.customerDetails.address2}}</p>
                        <p>{{this.customerDetails.address3}}</p>
                        <p>{{this.customerDetails.town}}</p>
                        <p>{{this.customerDetails.county}}</p>
                        <p>{{this.customerDetails.postcode}}</p>
                    </div>
                </div>

                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="orderInformation = !orderInformation">
                            <span v-if="this.orderInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.orderInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Order Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.orderInformation">
                        <p class="text_colour-909399">Order No</p>
                        <p>{{this.orderOverview.orderId}}</p>
                        <br>
                        <p class="text_colour-909399">Order Reference</p>
                        <!-- <p>{{this.orderOverview.jobName}}</p> -->
                        <p>{{formatOrderRef(this.orderOverview)}}</p>
                        <br>
                        <p class="text_colour-909399">Status</p>
                        <p>{{this.orderOverview.status}}</p>
                        <br>
                        <p class="text_colour-909399">Date</p>
                        <p>{{formatDateDDMMYYYY(this.orderOverview)}}</p>
                        <br>
                        <p class="text_colour-909399">Filename</p>
                        <p>{{this.orderOverview.orderFilename}}</p>
                    </div>
                </div>

                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="paymentInformation = !paymentInformation">
                            <span v-if="this.paymentInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.paymentInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Payment Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.paymentInformation">
                        <p class="text_colour-909399">Voucher Code</p>
                        <p v-show="this.job.voucherUsed === 'PFBULK5PLUS'">Bulk Discount - 5</p>
                        <p v-show="this.job.voucherUsed === 'PFBULK10PLUS'">Bulk Discount - 10</p>
                        <p v-show="this.job.voucherUsed !== 'PFBULK5PLUS' && this.job.voucherUsed !== 'PFBULK10PLUS'">
                            {{this.job.voucherUsed}}</p>
                        <br>
                        <p class="text_colour-909399">Voucher Discount </p>
                        <p>£{{this.job.voucherValue}}</p>
                        <br>
                        <p class="text_colour-909399">Subtotal (ex. VAT)</p>
                        <p>£{{this.orderOverview.billNetTotal}}</p>
                        <br>
                        <p class="text_colour-909399">VAT</p>
                        <p>£{{this.orderOverview.billVatTotal}}</p>
                        <br>
                        <p class="text_colour-909399">Total (inc. VAT)</p>
                        <p>£{{this.orderOverview.billGrossTotal}}</p>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__padding-20-0" v-show="this.role.includes('Customer')">
                <div class="layout__padding-clear text__align-center">
                    <el-button class="button-red layout__margin-20-0 layout__width-250px"
                               :disabled="this.orderOverview.despatched === null"
                               v-on:click="downloadCompleteOrders()">Download Completed Order
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "JobDetails",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        data() {
            return {
                job: {},
                orders: [],
                order: '',
                key: '',
                role: [],
                customerDetails: {},
                id: '',
                customerInformation: true,
                orderInformation: true,
                paymentInformation: true
            }
        },
        props: {
            orderOverview: {}
        },
        created() {

            this.id = this.$route.query.id
            console.log(this.id)
            // this.orderOverview = this.$route.query.orderOverview
            console.log(this.orderOverview)

            console.log(this.returnCookie("_role"))
            this.role = JSON.parse(this.returnCookie("_role"))


            if (typeof this.orderOverview === 'undefined') {
                if (window.sessionStorage.getItem('_directmailrOrder') !== null) {
                    this.orderOverview = JSON.parse(window.sessionStorage.getItem('_directmailrOrder'))

                    console.log(this.orderOverview)
                }
            }

            //const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id
            const url = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + this.id;

            // todo this is only an example to get some data populated on screen it needs to be the uri above
            // const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/2573`
            console.log('printing the url from the job level create method ' + url)
            Axios.get(url, this.returnAcceptHeader())
                .then(response => {

                    console.log('photofixr order information')
                    console.log(response.data)
                    this.job = response.data

                    this.job.jobCreated = new Date(this.job.jobCreated).toLocaleDateString('en-GB')
                    this.job.jobWorkCompletedDate = new Date(this.job.jobWorkCompletedDate).toLocaleDateString('en-GB')


                    if (this.orderOverview.customerRef !== 'PFCC1') {
                        const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=` + this.orderOverview.customerRef
                        // const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=XXX1`
                        console.log(customerUrl)
                        Axios.get(customerUrl, this.returnHeaderUsingToken())
                            .then(response => {
                                this.customerDetails = response.data.result
                                console.log(response.data.result)
                                console.log('customerDetails ' + this.customerDetails)
                            })
                    }

                });

        },
        beforeUpdate() {
            window.sessionStorage.setItem('_directmailrOrder', JSON.stringify(this.orderOverview));
        },
        methods: {
            downloadCompleteOrders() {
                const downloadComplete = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.id + '/DownloadCompleted'
                this.downloadLink(event, downloadComplete)
                event.stopPropagation();
            },
            stopPropagation() {
                event.stopPropagation();
            }
        }
    };
</script>